import { ErrorPage } from '@repo/internal-tools-app-lib/src/lib/ErrorPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

/**
 * All fields must be optional, because in reality, users can enter the page url directly
 * without specifying any search params.
 * Making them optional allows us to handle that case gracefully.
 */
type ErrorRouteSearchParams = {
  code?: string
  description?: string
}

export const Route = createFileRoute('/error')({
  validateSearch: (search: Record<string, string>): ErrorRouteSearchParams => {
    return { code: search.code, description: search.description }
  },
  component: ErrorRoute,
})

function ErrorRoute() {
  const { code, description } = Route.useSearch()

  return <ErrorPage code={code} description={description} />
}
